<template>
    <div id="turn">
        <img src="@/assets/images/template/loading.gif"/>
        <span>{{$t("trade.turn")}}</span>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "Turn",
        computed: {
            ...mapState(['quote','socket','account','group','symbolInfo','tradeData','user'])
        },
        watch:{
            quote:{
                deep:true,
                handler(newData,oldData){
                    if (newData.tickList.length > 0) {
                        this.$router.replace({path: this.$route.query.url, query: {turn: 1}});
                    }
                }
            }
        }
    }
</script>
